<template>
  <div class="container-fluid">
    <div class="row">
      <div v-for="(column, columnIndex) in numberColumns" v-bind:key="columnIndex" class="col">
        <home-card v-for="(house, index) in houseDataSubset" v-if="index % numberColumns == columnIndex"
          v-bind:key="house._id"
          v-bind:searchString="searchString"
          v-bind:data="house"
          v-on:mouseover.native="$emit('mouse-over', house._id)"
          v-on:mouseout.native="$emit('mouse-out', house._id)"
          v-on:login-required="loginRequired"></home-card>
      </div>
        <div class="mt-5 homapt-expandable card disclaimer">
          <p class="disclosure">The data relating to real estate for sale on this web site comes in part from the Broker Reciprocity<sup>SM</sup> Program of the Regional Multiple Listing Service of Minnesota, Inc. Real estate listings held by brokerage firms other than HomApt Realty are marked with the Broker Reciprocity<sup>SM</sup> logo or the Broker Reciprocity<sup>SM</sup> thumbnail logo (little black house) and detailed information about them includes the name of the listing brokers.</p>
          <p class="disclosure">Listing broker has attempted to offer accurate data, but buyers are advised to confirm all items.</p>
          <p class="disclosure">Copyright 2019 Regional Multiple Listing Service of Minnesota, Inc. All rights reserved.</p>
        </div>
    </div>
    <auth-modal ref="authModal"></auth-modal>
  </div>
</template>

<script>
import homeCard from './HomeCard.vue'
import AuthModal from '../../../authentication/TheAuthModal.vue'
const cardBatchIncrement = 25

export default {
  data () {
    return {
      windowWidth: 0,
      numberOfCardsToDisplay: cardBatchIncrement
    }
  },
  components: {
    'home-card': homeCard,
    AuthModal
  },
  props: {
    houseData: Array
  },
  computed: {
    searchString () {
      return this.$route.query.search
    },
    houseDataSubset () {
      return this.houseData.slice(0, this.numberOfCardsToDisplay)
    },
    numberColumns () {
      if (this.windowWidth <= 1300) {
        return 1
      } else if (this.windowWidth <= 2000) {
        return 2
      }
      return 3
    }
  },
  methods: {
    loginRequired () {
      this.$refs.authModal.$refs.authModal.show()
    },
    onResize () {
      this.windowWidth = window.innerWidth
    },
    loadMoreResults () {
      if (this.numberOfCardsToDisplay <= this.houseData.length) {
        this.numberOfCardsToDisplay += cardBatchIncrement
      }
    }
  },
  mounted () {
    this.onResize()
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  }
}
</script>

<style scoped>
.card {
  padding: 1rem;
  border-radius: 10px;
  margin: .7rem !important;
  cursor: pointer;
}

.row {
  margin-right: 1rem;
  margin-left: .1rem;
}

.disclosure {
  margin-bottom: 0;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeSearch/rightSide/HouseData.vue